module.exports = __webpack_public_path__ + "static/media/2-apr13sep13.63b14d11.pdf";